
import React, { ReactNode } from "react";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { LucideIcon } from "lucide-react";

interface RegulationItemProps {
  value: string;
  icon: LucideIcon;
  iconColor?: string;
  title: string;
  children: ReactNode;
}

export const RegulationItem = ({
  value,
  icon: Icon,
  iconColor = "text-tribal-primary",
  title,
  children,
}: RegulationItemProps) => {
  return (
    <AccordionItem value={value}>
      <AccordionTrigger className="text-tribal-secondary font-medium">
        <div className="flex items-center gap-2">
          <Icon className={`h-5 w-5 ${iconColor}`} />
          <span>{title}</span>
        </div>
      </AccordionTrigger>
      <AccordionContent>{children}</AccordionContent>
    </AccordionItem>
  );
};
